import { render } from "./customer-segments.vue?vue&type=template&id=bd52a9fa&scoped=true"
import script from "./customer-segments.vue?vue&type=script&lang=js"
export * from "./customer-segments.vue?vue&type=script&lang=js"

import "./customer-segments.vue?vue&type=style&index=0&id=bd52a9fa&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd52a9fa"]])

export default __exports__